import React, { useState, useEffect } from "react";
import { Image } from "antd";
import { Card } from "antd";
import { Progress } from "antd";
import { Skeleton, Popover } from "antd";
import Chip from "@mui/material/Chip";
// import Popover from '@mui/material/Popover';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import { FILE_PATH } from "../../commonFunctions/FilePaths";
import { Button } from "@mui/material";

const CourseItem = ({ course, filledPercent }) => {
  const [percent, setPercent] = useState(filledPercent);
  const [loading, setLoading] = useState(true);
  const approvalTypeId = course.course.approvalType.id;

  useEffect(() => {
    setPercent(filledPercent);
  }, [filledPercent]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Skeleton loading={loading} active avatar>
      <div className="my-3">
        {/* <Badge.Ribbon text={status} color={status === "Draft" ? "cyan" : status === "Approved" ? "green" : status === "Requested" ? "yellow" : status === "Disapproved" ? "red" : "lime"}> */}
        <Card className="card-item">
          <div className="row">
            <div className="col-md-2 pr-0">
              <Image
                width={100}
                src={
                  course.course.img === null
                    ? "https://i0.wp.com/iubs.org/wp-content/uploads/2021/12/blank.jpg?fit=300%2C300&ssl=1"
                    : FILE_PATH + course.course.img
                }
                placeholder={
                  <Image
                    preview={false}
                    src={
                      course.course.img === null
                        ? "https://i0.wp.com/iubs.org/wp-content/uploads/2021/12/blank.jpg?fit=300%2C300&ssl=1"
                        : FILE_PATH + course.course.img
                    }
                    width={100}
                  />
                }
              />
            </div>

            <div className="col-md-10 p-0 card-main">
              <h5 className="card-title">
                <b>
                  {course.course.courseTitle === null
                    ? "N/A"
                    : course.course.courseTitle}
                </b>{" "}
                {approvalTypeId === "2" && (
                  <a
                    className="mx-2"
                    href={`edit-course?code=${course.course.code}`}
                  >
                    <EditIcon style={{ color: "black" }} />
                  </a>
                )}{" "}
              </h5>
              <p className="availblity">
                {course.course.courseCategory.name === null
                  ? "N/A"
                  : course.course.courseCategory.name}
              </p>

              <div>
                <span className="pending-text">
                  {approvalTypeId !== null && approvalTypeId !== undefined &&
                  approvalTypeId === "1" ? (
                    <Chip
                      label="Please Await our Feedback"
                      color="secondary"
                      variant="outlined"
                    />
                  ) : approvalTypeId === "2" ? (
                    <Popover content={course.course.comment}>
                      <Chip
                        icon={<MoreVertIcon />}
                        label="Course approval rejected"
                        color="primary"
                        variant="outlined"
                      />
                    </Popover>
                  ) : approvalTypeId === "3" ? (
                    <Chip
                      label="Course creation in progress"
                      color="success"
                      variant="outlined"
                    />
                  ) : approvalTypeId === "4" ? (
                    <Chip
                      label="Disapproved"
                      color="primary"
                      variant="outlined"
                    />
                  ) : approvalTypeId === "5" ? (
                    <Chip label="Published" color="success" variant="outlined" />
                  ) : (
                    approvalTypeId === "7" && (
                      <Chip
                        label="Course approval requested"
                        color="warning"
                        variant="outlined"
                      />
                    )
                  )}
                </span>
                <div className="ant-progress-outer" style={{ width: "calc(100% - 10px)" }}>
                  <Progress percent={percent} />
                </div>
              </div>
            </div>
          </div>

          {approvalTypeId !== null && approvalTypeId !== undefined &&
            approvalTypeId === 3 && (
              <div className="d-flex justify-content-end mt-3">
                <Button variant="outlined">
                  <a
                    style={{ color: "#17082d" }}
                    href={`/courses/manage/${course.course.code}/`}
                  >
                    Manage Course
                  </a>
                </Button>
              </div>
            )}

          {approvalTypeId !== null && approvalTypeId !== undefined &&
            approvalTypeId === 4 && (
              <div className="d-flex justify-content-end mt-3">
                <Button variant="outlined">
                  <a
                    style={{ color: "#17082d" }}
                    href={`/courses/manage/${course.course.code}/`}
                  >
                    Manage Course
                  </a>
                </Button>
              </div>
            )}

          {approvalTypeId !== null && approvalTypeId !== undefined &&
            approvalTypeId === 5 && (
              <div className="d-flex justify-content-end mt-3">
                <Button variant="outlined">
                  <a
                    style={{ color: "#17082d" }}
                    href={`/courses/manage/${course.course.code}/`}
                  >
                    Manage Course
                  </a>
                </Button>
              </div>
            )}

          {approvalTypeId !== null && approvalTypeId !== undefined &&
            approvalTypeId === 6 && (
              <div className="d-flex justify-content-end mt-3">
                <Button variant="outlined">
                  <a
                    style={{ color: "#17082d" }}
                    href={`/courses/manage/${course.course.code}/`}
                  >
                    Manage Course
                  </a>
                </Button>
              </div>
            )}
        </Card>
      </div>
    </Skeleton>
  );
};

export default CourseItem;
